
<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">ACS Service Center </li>
            </ol>
          </div>
          <h4 class="page-title">Terminal prepping</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Terminal prepping</h4>
          <p class="sub-header">

          </p>

          <div class="row">
            <div class="form-group" *ngIf="raiseWarning" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert [dismissible]="false" style="width:100%;">
                  <strong>Warning!</strong> {{warning}}
                </ngb-alert>
              </div>
            </div>

            <div class="form-group" *ngIf="raiseDanger" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert type="danger" [dismissible]="false" style="width:100%;">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>
          </div>


          <div class="col-12">

            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
              <thead>
                <tr>
                  <th style="width:25%;">New request</th>
                  <th style="width:25%;">Terminal preparation</th>
                  <th style="width:25%;">Configuration complete</th>
                  <th style="width:25%;">Dispatched</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let n of terminalSignUpDefault">
                  <td>
                    <div class="card" style="width: 18rem;" *ngFor="let terminal of newTerminalsBulk">
                      <div class="card-header">
                        <b>{{terminal.merchantName}}</b>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="deleteTerminal(terminal, true)" *ngIf="canDeleteTicket">
                          <span aria-hidden="true"><i class="mdi mdi-trash-can-outline" style="color:red;"></i></span>
                        </button>&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="viewbulkOrders(terminal)" alt="Terminals">
                          <span aria-hidden="true"><i class="mdi mdi-format-list-bulleted" style="color:green;"></i></span>
                        </button>
                      </div>

                      <div class="card-body">
                        <h2>BULK</h2>
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ terminal.merchantNumber}}</b><br />
                        <p class="card-text">Terminal onboarded by <b>{{terminal.changedBy}}</b> on the <b>{{terminal.changedOn.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a'}}</b></p>
                        <button type="button" class="btn btn-primary" (click)="editBulk(terminal)" *ngIf="canEditTerminalSignUp">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          Claim ticket
                        </button>
                      </div>
                    </div>
                    <div class="card" style="width: 18rem;" *ngFor="let terminal of newTerminals ">
                      <div class="card-header">
                        <b>{{terminal.merchantName}}</b>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="deleteTerminal(terminal, false)" *ngIf="canDeleteTicket">
                          <span aria-hidden="true"><i class="mdi mdi-trash-can-outline" style="color:red;"></i></span>
                        </button>&nbsp;
                      </div>

                      <div class="card-body" *ngIf="!terminal.bulkOrder">
                        <!--style="background-color: gainsboro"-->
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-tablet" alt="Terminal Id"></i>TID: {{ terminal.terminalId}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ terminal.merchantNumber}}</b><br />
                        <!--<b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>WYBL: {{ terminal.wayBill}}</b><br />-->
                        <p class="card-text">Terminal onboarded by <b>{{terminal.changedBy}}</b> on the <b>{{terminal.changedOn.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a' }}</b></p>
                        <button type="button" class="btn btn-primary" (click)="editTerminal(terminal)" *ngIf="canEditTerminalSignUp">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          Claim ticket
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="card" style="width: 18rem;" *ngFor="let terminal of terminalsOnPrepBulk">
                      <div class="card-header">
                        <b>{{terminal.merchantName}}</b>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="editBulk(terminal)" *ngIf="canEditTerminalSignUp">
                          <span aria-hidden="true"><i class="mdi mdi-pen" style="color:Teal;"></i></span>
                        </button>&nbsp;
                      </div>
                      <div class="card-body">
                        <h2>BULK</h2>
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ terminal.merchantNumber}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>WYBL: {{ terminal.wayBill}}</b><br />
                        <p class="card-text">
                          Terminal onboarded by <b>{{terminal.changedBy}}</b> on the <b>{{terminal.changedOn.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a'}}</b>
                          In preparation by <b>{{terminal.inUseBy}}.</b> Last interaction date: <b>{{terminal.inUseDate.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a' }}</b>
                        </p>
                        <button type="button" class="btn btn-primary" (click)="editBulk(terminal)" *ngIf="canEditTerminalSignUp">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          {{inUseBy(terminal)}}
                        </button>&nbsp;
                        <button type="button" class="btn btn-primary" (click)="editBulk(terminal)" *ngIf="client">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          View ticket
                        </button>
                      </div>
                    </div>
                    <div class="card" style="width: 18rem;" *ngFor="let terminal of terminalsOnPrep ">
                      <div class="card-header">
                        <b>{{terminal.merchantName}}</b>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="editTerminal(terminal)" *ngIf="canEditTerminalSignUp">
                          <span aria-hidden="true"><i class="mdi mdi-pen" style="color:Teal;"></i></span>
                        </button>&nbsp;
                      </div>
                      <div class="card-body">
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-tablet" alt="Terminal Id"></i>TID: {{ terminal.terminalId}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-paperclip" alt="Serial Nr"></i>S/N: {{ terminal.serialNumber}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ terminal.merchantNumber}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>WYBL: {{ terminal.wayBill}}</b><br />
                        <p class="card-text">
                          Terminal onboarded by <b>{{terminal.changedBy}}</b> on the <b>{{terminal.changedOn.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a' }}</b>.
                          Inpreparation by <b>{{terminal.inUseBy}}.</b>  Last interaction date: <b>{{terminal.inUseDate.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a' }}</b>
                        </p>
                        <button type="button" class="btn btn-primary" (click)="editTerminal(terminal)" *ngIf="canEditTerminalSignUp">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          {{inUseBy(terminal)}}
                        </button>&nbsp;
                        <button type="button" class="btn btn-primary" (click)="editTerminal(terminal)" *ngIf="client">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          View ticket
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="card" style="width: 18rem;" *ngFor="let terminal of configurationCompleteBulk">

                      <div class="card-header">
                        <b>{{terminal.merchantName}}</b>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="dispatch(terminal, 'bulk')" *ngIf="canDispatchTerminals">
                          <span aria-hidden="true"><i class="mdi mdi-checkbox-marked-circle-outline" style="color:Teal;"></i></span>
                        </button>&nbsp;
                      </div>

                      <div class="card-body">
                        <h2>BULK</h2>
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ terminal.merchantNumber}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>WYBL: {{ terminal.wayBill}}</b><br />
                        <p class="card-text">Terminal onboarded by <b>{{terminal.changedBy}}</b> on the <b>{{terminal.changedOn.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a'}}</b></p>
                        <p class="card-text">Prepared by <b>{{terminal.inUseBy}}</b> <br /> Last interaction date: <b>{{terminal.inUseDate.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a' }}</b></p>
                        <button type="button" class="btn btn-primary" (click)="editBulk(terminal)" *ngIf="canEditTerminalSignUp">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          {{inUseBy(terminal)}}
                        </button>&nbsp;
                        <button type="button" class="btn btn-primary" (click)="editBulk(terminal)" *ngIf="client">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          View ticket
                        </button>
                      </div>
                    </div>
                    <div class="card" style="width: 18rem;" *ngFor="let terminal of configurationComplete ">

                      <div class="card-header">
                        <b>{{terminal.merchantName}}</b>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="dispatch(terminal, 'single')" *ngIf="canDispatchTerminals">
                          <span aria-hidden="true"><i class="mdi mdi-checkbox-marked-circle-outline" style="color:Teal;"></i></span>
                        </button>&nbsp;
                      </div>


                      <div class="card-body">
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-tablet" alt="Terminal Id"></i>TID: {{ terminal.terminalId}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-paperclip" alt="Serial Nr"></i>S/N: {{ terminal.serialNumber}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ terminal.merchantNumber}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>WYBL: {{ terminal.wayBill}}</b><br />
                        <p class="card-text">
                          Terminal onboarded by <b>{{terminal.changedBy}}</b> on the <b>{{terminal.changedOn.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a'}}.</b>
                          Prepared by <b>{{terminal.inUseBy}}</b> <br /> Last interaction date: <b>{{terminal.inUseDate.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a' }}</b>
                        </p>
                        <button type="button" class="btn btn-primary" (click)="editTerminal(terminal)" *ngIf="canEditTerminalSignUp">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          {{inUseBy(terminal)}}
                        </button>&nbsp;
                        <button type="button" class="btn btn-primary" (click)="editTerminal(terminal)" *ngIf="client">
                          <i class="mdi mdi-pencil-box-outline"></i>
                          View ticket
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="card" style="width: 18rem;" *ngFor="let terminal of dispatchedTerminalsBulk">
                      <div class="card-header">
                        <b>{{terminal.merchantName}}</b>
                        <button type="button" class="close" aria-label="Close" (click)="resetTerminal(terminal, true)" *ngIf="canResetTerminalTicket">
                          <span aria-hidden="true"><i class="mdi mdi-recycle" style="color: #0069d9;"></i></span>
                        </button>&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="retrySendingNotification(terminal, 'bulk')" *ngIf="canGenerateRemedyCall">
                          <span aria-hidden="true"><i class="mdi mdi-email-variant" style="color: Teal;"></i></span>
                        </button>&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="archiveTerminal(terminal, true)" *ngIf="canArchiveTerminalTicket">
                          <span aria-hidden="true"><i class="mdi mdi-archive" style="color: Teal;"></i></span>
                        </button>
                      </div>
                      <div class="card-body">
                        <h2>BULK</h2>
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ terminal.merchantNumber}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>WYBL: {{ terminal.wayBill}}</b><br />
                        <p class="card-text">
                          Terminal onboarded by <b>{{terminal.changedBy}}</b> on the <b>{{terminal.changedOn.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a'}}</b>
                          Prepared by <b>{{terminal.inUseBy}}.</b> Last interaction date: <b>{{terminal.inUseDate.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a' }}</b>
                        </p>
                        <div class="row">
                          <button type="button" *ngIf="trackTerminal(terminal)" class="btn btn-warning" (click)="viewTrackTerminal(terminal)">
                            <i class="fa fa-truck"></i>
                            Track
                          </button>
                          &nbsp;
                          <button type="button" class="btn btn-success" (click)="viewDeliveryNote(terminal)" *ngIf="canEditTerminalSignUp">
                            <i class="mdi mdi-pencil-box-outline"></i>
                            Delivery note
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card" style="width: 18rem;" *ngFor="let terminal of dispatchedTerminals ">
                      <div class="card-header">
                        <b>{{terminal.merchantName}}</b>
                        <button type="button" class="close" aria-label="Close" (click)="resetTerminal(terminal, false)" *ngIf="canResetTerminalTicket">
                          <span aria-hidden="true"><i class="mdi mdi-recycle" style="color: #0069d9;"></i></span>
                        </button>&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="retrySendingNotification(terminal, 'single')" *ngIf="canGenerateRemedyCall">
                          <span aria-hidden="true"><i class="mdi mdi-email-variant" style="color: Teal;"></i></span>
                        </button>&nbsp;
                        <button type="button" class="close" aria-label="Close" (click)="archiveTerminal(terminal, false)" *ngIf="canArchiveTerminalTicket">
                          <span aria-hidden="true"><i class="mdi mdi-archive" style="color:Teal;"></i></span>
                        </button>
                      </div>
                      <div class="card-body">
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-tablet" alt="Terminal Id"></i>TID: {{ terminal.terminalId}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-paperclip" alt="Serial Nr"></i>S/N: {{ terminal.serialNumber}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fe-airplay" alt="Merchant number"></i>MID: {{ terminal.merchantNumber}}</b><br />
                        <b class="font-weight: 500; font-family: 'Roboto', sans-serif;"><i class="fa fa-truck" alt="Waybill"></i>WYBL: {{ terminal.wayBill}}</b><br />
                        <p class="card-text">
                          Terminal onboarded by <b>{{terminal.changedBy}}</b> on the <b>{{terminal.changedOn.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a'}}.</b>
                          Prepared by <b>{{terminal.inUseBy}}.</b> Last interaction date: <b>{{terminal.inUseDate.getTime() - 2 * 60 * 60 * 1000 | date: 'dd/MM/yyyy hh:mm a' }}</b>
                        </p>
                        <div class="row">
                          <button type="button" *ngIf="trackTerminal(terminal)" class="btn btn-warning" (click)="viewTrackTerminal(terminal)">
                            <i class="fa fa-truck-moving"></i>
                            Track
                          </button>
                          &nbsp;&nbsp;
                          <button type="button" class="btn btn-success" (click)="viewDeliveryNote(terminal)" *ngIf="canEditTerminalSignUp">
                            <i class="mdi mdi-pencil-box-outline"></i>
                            Delivery note
                          </button>
                        </div>


                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>



        </div>
      </div>
    </div>
  </div>
</div>
